import React, { useState, useEffect } from "react";
import Headerdash from "../head";
import Sidebar from "../sidebar";
import SpacingBox from "./Spacing";
import HeadingPage from "./Heading";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { useParams } from "react-router-dom";
import useFetchData from "../fetchpostData";
import ScoreBoxForReOrderPara from "./ResponseBoxForReOrderPara";
import Notification from "./Notification";
import ScoreCardForReading from "./ScoreBoxForReadingSection";
import Timers from "../PageComponent/Timers";

import Sentence from "./DragAndDrop"; // Update the import to the correct component path

export default function ReOrderParagraphPage() {
  const { title } = useParams();
  const section = "reorderparagraph";
  const practiceItemId = title;

  const post = useFetchData(section, title); // Use the hook

  const [originalSentences, setOriginalSentences] = useState([]);
  const [draggableSentences, setDraggableSentences] = useState([]);
  const [Title, setTitle] = useState("");
  const [originalAnswer, setOriginalAnswer] = useState("");
  const [userId, setUserId] = useState("");
  const [username, setUsername] = useState("");
  const [practiceType, setPracticeType] = useState("");
  const [isAttempted, setIsAttempted] = useState(false);
  const [message, setMessage] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [notificationType, setNotificationType] = useState("");
  const [savedPractice, setSavedPractice] = useState(null); // New state to store saved practice data
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (post && post.q_title) {
      setTitle(post.q_title);
      const fetchedSentences = post.option.map((option) => ({
        ...option,
        text: option.options,
        originalIndex: option.index - 1, // Adjusting index to be 0-based
      }));

      setOriginalSentences(fetchedSentences);
      const shuffledDraggable = shuffleArray([...fetchedSentences]);
      setDraggableSentences(shuffledDraggable);
    }
  }, [post]);

  const moveSentence = (dragIndex, hoverIndex) => {
    const newSentences = [...draggableSentences];
    const draggedSentence = newSentences[dragIndex];

    newSentences.splice(dragIndex, 1);
    newSentences.splice(hoverIndex, 0, draggedSentence);
    setDraggableSentences(newSentences);
  };

  const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };

  const savePractice = async (practiceData) => {
    try {
      const response = await fetch("/api/save-reorderparagraph", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(practiceData),
      });

      if (!response.ok) {
        throw new Error("Failed to save practice data");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  };

  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSubmitted(true);
    const userOrder = draggableSentences.map(
      (sentence) => sentence.originalIndex + 1
    );
    console.log("User's order of sentences:", userOrder.join(","));
    const answer = userOrder.join(",");
    const practiceType = section;
    setOriginalAnswer(answer);

    const practiceData = {
      practiceType,
      practiceItemId,
      response: {
        questionId: practiceItemId,
        answer,
        isAttempted,
      },
    };
    console.log("practiceData:", practiceData);
    try {
      const result = await savePractice(practiceData);
      console.log("Practice data saved:", result);
      setMessage("Practice data saved successfully!");
      setNotificationType("success");
      setSavedPractice(result);
      setShowNotification(true); // Show notification

      setTimeout(() => {
        setIsAttempted(true);
        setLoading(false);
        setSubmitted(true);
      }, 2000);
    } catch (error) {
      console.error("Error saving practice data:", error);
      setMessage("Failed to save practice data.");
      setNotificationType("error");
      setShowNotification(true); // Show notification
      setLoading(false);
      setSubmitted(false);
    }
  };

  const handleCloseNotification = () => {
    setShowNotification(false);
  };

  console.log("savedPractice", savedPractice);

  // Callback function to handle the isAttempted value from the child component
  const handleIsAttempted = (isAttemptedValue) => {
    setIsAttempted(isAttemptedValue);
  };

  const handleRetake = () => {
    setSubmitted(false);
    setIsAttempted(false);
    const shuffledDraggable = shuffleArray([...originalSentences]);
    setDraggableSentences(shuffledDraggable);
    setSubmitted(false);
  };
  const attemptedStatus = isAttempted ? "Attempted" : "Not Attempted";

  return (
    <div>
      <Headerdash />
      <Sidebar />
      <div className="relative md:left-72 left-0 md:ml-3 top-28 bg-gray-100 h-auto w-full md:w-[1150px] rounded-sm p-4 ">
        <HeadingPage
          title={Title}
          timer={<Timers initialSeconds={0} />} // Use the Timer component here
          difficulty="Medium"
          attempted={attemptedStatus}
        />
        <h3 class="mx-auto px-5 text-base sm:text-lg md:text-xl lg:text-base leading-relaxed">
          The textbox in the left panel have been placed in a random order.
          Restore the original order by dragging the text boxes from the left
          panel to the right panel.
        </h3>
        <DndProvider backend={HTML5Backend}>
          <div className="flex flex-col md:flex-row">
            <div className="w-full md:w-1/2 pr-0 md:pr-5 p-4">
              <h2 className="text-lg font-semibold mb-3">Original Sentences</h2>
              <div className="border border-gray-300 rounded-md p-4 bg-blue-100">
                {originalSentences.map((sentence) => (
                  <div
                    key={sentence.id}
                    className="p-2 border border-gray-300 rounded-md bg-blue-50"
                  >
                    {sentence.options}
                  </div>
                ))}
              </div>
            </div>
            <div className="w-full md:w-1/2 pl-0 ml-4 md:pl-5 p-4">
              <h2 className="text-lg font-semibold mb-3">
                Draggable Sentences
              </h2>
              <div className="border border-gray-300 rounded-md p-4 bg-green-100">
                {draggableSentences.map((sentence, index) => (
                  <Sentence
                    key={sentence.id}
                    sentence={sentence}
                    index={index}
                    correctIndex={sentence.originalIndex}
                    moveSentence={moveSentence}
                    submitted={submitted}
                  />
                ))}
              </div>
            </div>
          </div>
        </DndProvider>

        <div className="flex space-x-4 mt-4">
          <button
            className="bg-blue-800 hover:bg-blue-500 text-white font-semibold py-1 px-4 ml-5 rounded-sm"
            onClick={handleSubmit}
            disabled={submitted}
          >
            <span className="flex items-center justify-center">
              {loading ? (
                <>
                  <svg
                    className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  <span>Submitting...</span>
                </>
              ) : (
                "Submit"
              )}
            </span>
          </button>

          {submitted && (
            <button
              type="button"
              onClick={handleRetake}
              className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-1 px-4 rounded-sm"
            >
              Retake
            </button>
          )}
        </div>

        {submitted ? (
          <>
            <div className="flex items-center justify-center h-72 bg-gray-100">
              <ScoreCardForReading
                score={savedPractice?.savedResponse.totalScore}
                maxScore={3}
              />
            </div>
          </>
        ) : null}
        <ScoreBoxForReOrderPara
          // originalWords={originalAnswer}
          practiceItemId={practiceItemId}
          onIsAttempted={handleIsAttempted}
        />
        {showNotification && (
          <Notification
            message={message}
            type={notificationType}
            onClose={handleCloseNotification}
          />
        )}
        <SpacingBox />
      </div>
    </div>
  );
}
